<template>
  <v-btn
    v-bind="{ ...$attrs, ...commonAttrs }"
    v-on="$listeners"
    :color="computedColor"
    :class="classNames">
    <template
      v-for="(_, scopedSlotName) in $scopedSlots"
      #[scopedSlotName]="slotData">
      <slot :name="scopedSlotName" v-bind="slotData" />
    </template>
    <template v-for="(_, slotName) in $slots" #[slotName]>
      <slot :name="slotName" />
    </template>
  </v-btn>
</template>
<script>
export default {
  inheritAttrs: false,
  props: {
    type: { type: String, default: 'secondary' }
  },
  computed: {
    computedColor() {
      return this.type == 'primary' ? 'hfr' : 'white';
    },
    classNames() {
      return [this.type == 'primary' ? 'white--text' : 'hfr--text'];
    },
    commonAttrs() {
      return {
        block: true,
        elevation: 2,
        outlined: false
      };
    }
  }
};
</script>
<style lang="scss" scoped></style>
